import React from 'react';
// import React from 'react-native-elements';
import {useMutation} from "@apollo/client";
import {MARK_ASSIGNMENT} from "../query";
import {clientV2} from "../../../common";
import {View, Text} from "react-native";

interface IMarkAssignMentMutation {
    children: ({
                   markAssignmentMutation
               }) => JSX.Element;
}

export const MarkAssignMentMutation = (props: IMarkAssignMentMutation) => {
    const [markAssignmentMutation, {data}] = useMutation(MARK_ASSIGNMENT, {client: clientV2});
    return props.children({markAssignmentMutation})
};